import { APIServices } from './axiosCommon';

export interface AuthUserDto {
  uid: number;
  username: string | null;
  email: string | null;
  firstname: string | null;
  lastname: string | null;
  accessLevel: number;
  tfstaff: boolean;
  verified: number;
  roles: string[];
  permissions: { module: string; action: string }[];
}

interface AuthEnvelope {
  success: boolean;
  data: { user: AuthUserDto };
}

export const authApi = {
  login: (input: { username?: string; email?: string; password: string }) =>
    APIServices.post<AuthEnvelope>('/auth/login', input),

  me: () => APIServices.get<AuthEnvelope>('/auth/me'),

  refresh: () => APIServices.post<AuthEnvelope>('/auth/refresh'),

  logout: () => APIServices.post<{ success: boolean }>('/auth/logout'),
};
